export default "__VITE_ASSET__3524d4bd__"